import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Moon, Sun, LogOut } from "lucide-react";

const ROLE_LABEL = { admin: "Administrator", teacher: "Tutor", parent: "Parent" };

export function AppLayout({ children, title, subtitle, actions }) {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 flex items-center justify-between h-16">
          <Logo compact />
          <div className="flex items-center gap-2 sm:gap-3">
            {user && (
              <div className="hidden sm:flex flex-col items-end mr-1">
                <span className="text-sm font-medium leading-none">{user.name}</span>
                <span className="eyebrow text-[9px] text-muted-foreground mt-1">
                  {ROLE_LABEL[user.role] || user.role}
                </span>
              </div>
            )}
            <Button
              variant="outline"
              size="icon"
              onClick={toggle}
              data-testid="theme-toggle-button"
              className="rounded-full"
            >
              {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={logout}
              data-testid="logout-button"
              className="rounded-full"
            >
              <LogOut className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Sign out</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="eyebrow text-[10px] text-muted-foreground mb-2">{ROLE_LABEL[user?.role]} Portal</div>
            <h1 className="font-brand font-light tracking-tight text-3xl sm:text-4xl">{title}</h1>
            {subtitle && <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p>}
          </div>
          {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
        </div>
        {children}
      </main>
    </div>
  );
}
